// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { accountMessagesStyles } from "@insite/content-library/Widgets/MyAccount/AccountMessages";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

accountMessagesStyles.messagesAccordion = {
    css: css`
        width: 100%;
        border-bottom: 1px solid ${getColor("common.border")};

        [class^="AccordionSectionPanel"] {
            padding-left: 40px;
        }
    `,
};

accountMessagesStyles.messageCard!.bottomBorder = {
    css: css`
        ${accountMessagesStyles.messageCard!.bottomBorder!.css};
        background: ${getColor("common.border")};
    `,
};

accountMessagesStyles.messageCard!.article = {
    css: css`
        ${accountMessagesStyles.messageCard!.article!.css};
        position: relative;
    `,
};

accountMessagesStyles.messageCard!.actionButton = {
    css: css`
        ${accountMessagesStyles.messageCard!.actionButton!.css};

        ${({ theme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                         {
                            position: relative;
                            margin-bottom: 10px;
                        }
                    `,
                    null,
                    css`
                         {
                            position: absolute;
                            top: 0;
                            right: 0;
                        }
                    `,
                    null,
                    null,
                ],
                "min",
            )}
    `,
};

accountMessagesStyles.messageCardGridItem = {
    width: 12,
    css: css`
        ${accountMessagesStyles.messageCardGridItem!.css};
        &:last-child {
            div:last-child {
                div {
                    background: none;
                }
            }
        }
    `,
};

accountMessagesStyles.messageFilterGridItem = {
    width: 12,
    css: css`
        flex-wrap: wrap;
    `,
};

accountMessagesStyles.messageFilter = {
    radioGroup: {
        css: css`
            display: flex;
            flex-direction: row;
            align-items: center;
            flex-wrap: wrap;

            div[class^="RadioStyle"] {
                margin-top: 10px;

                label {
                    margin-right: 30px;
                }
            }
        `,
    },
};

accountMessagesStyles.messagesSection = {
    css: css`
        ${accountMessagesStyles.messagesSection?.css}
        dt[data-test-selector="sectionHeader"] button {
            position: relative;
        }
    `,
};
